import { getFilterRequest, updateBeamUrl } from '@utils';
import { useState } from 'react';
import { useAppSelector } from '@store/redux/store';
import { useMutation } from 'react-query';
import { exportEquipmentsToCsv } from '@services/queries/equipments';
import {
  EQUIPMENTS_PICKER_SEND_TYPE,
  EQUIPMENTS_PICKER_STATE_TYPE,
} from '@store/machines/equipmentsPicker';
import { isMassEditing } from './logic/isMassEditing';
import {
  Button,
  DeleteButton,
  Loading,
  MenuButton,
  WhiteButton,
} from './Products.styles';
import ProductsPageMenu from './components/ProductsPageMenu/ProductsPageMenu';

export const SELECT_ALL_LIMIT = 100000;

interface ExtraMenuOptionsProps {
  state: EQUIPMENTS_PICKER_STATE_TYPE;
  send: EQUIPMENTS_PICKER_SEND_TYPE;
}
export function ExtraMenuOptions(props: ExtraMenuOptionsProps) {
  const { state, send } = props;

  const { context } = state;
  const showMassEditOpts = isMassEditing(state);

  // Csv, etc
  const { filter, inventory } = useAppSelector();

  const [loadingExport, setLoadingExport] = useState(false);
  const exportToCsv = useMutation(exportEquipmentsToCsv, {
    onSuccess: url => {
      setLoadingExport(false);
      window.open(updateBeamUrl(url), '_blank');
    },
    onError: () => {
      setLoadingExport(false);
    },
  });
  return (
    <>
      {showMassEditOpts && (
        <WhiteButton
          onClick={() => {
            send({ type: 'CANCEL' });
          }}
        >
          Cancel
        </WhiteButton>
      )}

      {(() => {
        if (showMassEditOpts) {
          return (
            <>
              <Button
                disabled={context.data.size === 0}
                onClick={() => {
                  send({ type: 'OPEN', modalName: 'MASS_EDIT' });
                }}
              >
                Launch Mass Edit
              </Button>
              <DeleteButton
                disabled={context.data.size === 0}
                onClick={() => {
                  send({ type: 'OPEN', modalName: 'DELETE_EQUIPMENTS' });
                }}
              >
                Delete Assets
              </DeleteButton>
            </>
          );
        }
        if (loadingExport) {
          return (
            <MenuButton>
              <Loading />
            </MenuButton>
          );
        }
        return (
          <ProductsPageMenu
            send={send}
            exportViewToCsv={() => {
              setLoadingExport(true);
              exportToCsv.mutate({
                pagination: {
                  page: 1,
                  limit: SELECT_ALL_LIMIT,
                  search: filter.searchBarText,
                },
                filter: getFilterRequest(
                  filter.options,
                  inventory.activeTab === 'equipment',
                ),
              });
            }}
            exportAllToCsv={() => {
              setLoadingExport(true);
              exportToCsv.mutate({
                pagination: {
                  page: 1,
                  limit: SELECT_ALL_LIMIT,
                },
                filter: { removeFieldConfiguration: true },
              });
            }}
          />
        );
      })()}
    </>
  );
}
